import FuseSidePanel from '@fuse/core/FuseSidePanel';
import { memo } from 'react'

/**
 * The left side layout 3.
 */
function LeftSideLayout3() {
	return (
		<FuseSidePanel className="flex flex-col justify-star items-center py-3 space-y-2">
			<div>
			</div>
		</FuseSidePanel>
	);
}

export default memo(LeftSideLayout3);
